import { useCreateAssociatedParty } from '@/shared/hooks/api/associatedParties'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { AssociatedPartyForm } from './AssociatedPartyForm'

type AddAssociatedPartyModalProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onAdded?: (id: string) => void
}

export function AddAssociatedPartyModal({
  open,
  onOpenChange,
  onAdded,
}: AddAssociatedPartyModalProps) {
  const { t } = useTranslation(['associatedParties', 'countries'])
  const { mutate: createParty, isPending } = useCreateAssociatedParty()

  const handleSubmit = (
    payload: Parameters<typeof createParty>[0]
  ) => {
    createParty(payload, {
      onSuccess: (data) => {
        toast.success(t('addModal.success'))
        onOpenChange(false)
        onAdded?.(data.id)
      },
      onError: (error) => {
        toast.error(error.message || t('addModal.error'))
      },
    })
  }

  const handleOpenChange = (next: boolean) => {
    onOpenChange(next)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className='flex max-h-[90vh] max-w-4xl! flex-col'>
        <DialogHeader>
          <DialogTitle>{t('addModal.title')}</DialogTitle>
        </DialogHeader>
        <AssociatedPartyForm
          open={open}
          inputIdPrefix='add-associated-party'
          onSubmit={handleSubmit}
          onCancel={() => handleOpenChange(false)}
          submitLabel={t('addModal.submit')}
          cancelLabel={t('addModal.cancel')}
          isPending={isPending}
        />
      </DialogContent>
    </Dialog>
  )
}
